import { useListInstantiationRequestsQuery } from '../../__generated__/chirp/com/hubspot/automation/templatesrpc/TemplateInstantiationService.hooks';
import { useResolveWorkflowLinksQuery } from '../../__generated__/chirp/com/hubspot/automation/embedded/rpc/AutomationEmbeddedServiceV2.hooks';
import { useMemo } from 'react';
import { useDetailsPageContext } from 'marketplace-ui-common/context/DetailsPageContext';
import { gate } from 'hub-http/gates';
import { getResolvedWorkflowPath, getWorkflowFlowUrl } from 'marketplace-ui-common/utils/DetailsPageUrls';
// This hook only supports workflow template usage at the moment, possibly will be used for agents in near future
export function useGetProductUsage({
  appContext,
  productType,
  sourceId,
  skip
}) {
  var _userInfo$gates;
  const {
    userInfo
  } = useDetailsPageContext();
  const sourceIdAsNumber = typeof sourceId === 'string' ? parseInt(sourceId, 10) : sourceId;
  const isUngatedForUnifiedBuilder = userInfo === null || userInfo === void 0 || (_userInfo$gates = userInfo.gates) === null || _userInfo$gates === void 0 ? void 0 : _userInfo$gates.includes(gate('Workflows:ModernEditor'));
  const {
    data: templateInstancesData,
    loading: templateInstancesLoading,
    error: templateInstancesError,
    refetch: refetchTemplateInstances
  } = useListInstantiationRequestsQuery({
    variables: {
      templateId: sourceIdAsNumber
    },
    skip: skip || appContext !== 'app' || productType !== 'WORKFLOW_TEMPLATE'
  });
  const flowIdsToResolve = useMemo(() => {
    var _templateInstancesDat;
    return (templateInstancesData === null || templateInstancesData === void 0 || (_templateInstancesDat = templateInstancesData.results) === null || _templateInstancesDat === void 0 ? void 0 : _templateInstancesDat.filter(instance => {
      var _instance$viewLocatio;
      return instance.status === 'COMPLETED' && !((_instance$viewLocatio = instance.viewLocation) !== null && _instance$viewLocatio !== void 0 && _instance$viewLocatio.url) && Boolean(instance.flowId);
    }).map(instance => instance.flowId)) || [];
  }, [templateInstancesData === null || templateInstancesData === void 0 ? void 0 : templateInstancesData.results]);
  const {
    data: workflowLinksData,
    loading: workflowLinksLoading
  } = useResolveWorkflowLinksQuery({
    variables: {
      flowIds: flowIdsToResolve
    },
    skip: flowIdsToResolve.length === 0 || appContext !== 'app'
  });
  const parsedTemplateInstances = useMemo(() => {
    var _templateInstancesDat2;
    return templateInstancesData === null || templateInstancesData === void 0 || (_templateInstancesDat2 = templateInstancesData.results) === null || _templateInstancesDat2 === void 0 ? void 0 : _templateInstancesDat2.filter(instance => instance.status === 'COMPLETED').map(instance => {
      var _instance$viewLocatio2;
      const resolvedPath = getResolvedWorkflowPath(workflowLinksData === null || workflowLinksData === void 0 ? void 0 : workflowLinksData.links.find(({
        flowId
      }) => flowId === instance.flowId));
      return {
        href: ((_instance$viewLocatio2 = instance.viewLocation) === null || _instance$viewLocatio2 === void 0 ? void 0 : _instance$viewLocatio2.url) || resolvedPath || getWorkflowFlowUrl(instance.flowId || 0, isUngatedForUnifiedBuilder, instance.targetType),
        createdBy: instance.userId,
        createdAt: instance.createdAt,
        workflowName: instance.workflowName
      };
    });
  }, [isUngatedForUnifiedBuilder, templateInstancesData === null || templateInstancesData === void 0 ? void 0 : templateInstancesData.results, workflowLinksData === null || workflowLinksData === void 0 ? void 0 : workflowLinksData.links]);
  switch (productType) {
    case 'WORKFLOW_TEMPLATE':
      return {
        usages: parsedTemplateInstances || [],
        loading: templateInstancesLoading || workflowLinksLoading,
        error: templateInstancesError,
        refetch: refetchTemplateInstances
      };
    default:
      break;
  }
  return {
    usages: [],
    loading: false,
    error: undefined,
    refetch: undefined
  };
}